
import { dayFunc } from "@/hooks/factoryFunc";
// 货币单位处理
import currency from 'currency.js';
const { dayjs } = dayFunc();
const util:any = {
    $tokenStr: 'hxToken',
    $origin: window.location.origin,
    $currency:currency,
    $dateFormat:{
        dateFormatPickerStr:function(str: string) :string{
            const b:number = new Date(str).getTime();
            const a:Date = new Date(b);
            const year:number|string = a.getFullYear();
            let month:number|string = a.getMonth() + 1;
            month = (month < 10) ? "0" + month : month;
            let date:number|string = a.getDate();
            date = (date < 10) ? "0" + date : date;
            return year + "-" + month + "-" + date;
        },
        dateFormatStr:function(str: string) :string{
            const b:number = new Date(str).getTime();
            const a:Date = new Date(b);
            const year:number|string = a.getFullYear();
            let month:number|string = a.getMonth() + 1;
            month = (month < 10) ? "0" + month : month;
            let date:number|string = a.getDate();
            date = (date < 10) ? "0" + date : date;
            let hours:number|string = a.getHours();
            hours = (hours < 10) ? "0" + hours : hours;
            let minutes:number|string = a.getMinutes();
            minutes = (minutes < 10) ? "0" + minutes : minutes;
            let seconds:number|string = a.getSeconds();
            seconds = (seconds < 10) ? "0" + seconds : seconds;
            return year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
        },
        dateFormat: function(b: number) :string{
            const time:number = b || new Date().getTime();
            const a:Date = new Date(time);
            const year:number = a.getFullYear();
            let month:number|string = a.getMonth() + 1;
            month = (month < 10) ? "0" + month : month;
            let date:number|string = a.getDate();
            date = (date < 10) ? "0" + date : date;
            let hours:number|string = a.getHours();
            hours = (hours < 10) ? "0" + hours : hours;
            let minutes:number|string = a.getMinutes();
            minutes = (minutes < 10) ? "0" + minutes : minutes;
            let seconds:number|string = a.getSeconds();
            seconds = (seconds < 10) ? "0" + seconds : seconds;
            return year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
        },
        dateFormatTime: function(b:number):string{
            b = b || new Date().getTime();
            const a = new Date(b);
            let hours:number|string = a.getHours();
            hours = (hours < 10) ? "0" + hours : hours;
            let minutes:number|string = a.getMinutes();
            minutes = (minutes < 10) ? "0" + minutes : minutes;
            let seconds:number|string = a.getSeconds();
            seconds = (seconds < 10) ? "0" + seconds : seconds;
            return hours + ":" + minutes + ":" + seconds;
        },
        dateFormatHours: function(b:number):string{
            b = b || new Date().getTime();
            const a = new Date(b);
            let hours:string|number = a.getHours();
            hours = (hours < 10) ? "0" + hours : hours;
            return hours+'时';
        },
        dateFormatOther: function(b:number):string{
            b = b || new Date().getTime();
            const a = new Date(b);
            const year:number|string = a.getFullYear();
            let month:number|string = a.getMonth() + 1;
            month = (month < 10) ? "0" + month : month;
            let date:number|string = a.getDate();
            date = (date < 10) ? "0" + date : date;
            return year + "-" + month + "-" + date;
        },
        dateFormatPicker:function(b:number):string{
            b = b || new Date().getTime()-90*24*3600*1000;
            const a = new Date(b);
            const year:number|string = a.getFullYear();
            let month:number|string = a.getMonth() + 1;
            month = (month < 10) ? "0" + month : month;
            let date:number|string = a.getDate();
            date = (date < 10) ? "0" + date : date;
            return year + "-" + month + "-" + date;
        },
        dateFormatDay:function(b:number):string{
            b = b || new Date().getTime();
            const a = new Date((b));
            const year:number|string = a.getFullYear();
            let month:number|string = (a.getMonth()) + 1;
            month = (month < 10) ? "0" + month : month;
            let date:number|string = a.getDate();
            date = (date < 10) ? "0" + date : date;
            return year + "-" + month + "-" + date + " ";
        },
        dateFormatMoth: function(b:number):string{
            b = b || new Date().getTime();
            const a = new Date((b));
            const year = a.getFullYear();
            let month:number|string = (a.getMonth()) + 1;
            month = (month < 10) ? "0" + month : month;
            return year + "-" + month ;
        },
        dateFormatYear:function(b:number):number{
            b = b || new Date().getTime();
            const a = new Date((b));
            const year = a.getFullYear();
            return year;
        },
        dateFormatOtherDay:function(b:number):string{
            b = b || new Date().getTime();
            const a = new Date((b));
            const year = a.getFullYear();
            let month:number|string = (a.getMonth()) + 1;
            month = (month < 10) ? "0" + month : month;
            let date:number|string = a.getDate();
            date = (date < 10) ? "0" + date : date;
            return year + "-" + month + "-" + date;
        },
        dateFormatOtherMonth:function(b:number):string{
            b = b || new Date().getTime();
            const a = new Date((b));
            const year = a.getFullYear();
            let month:number|string = (a.getMonth()) + 1;
            month = (month < 10) ? "0" + month : month;
            return year + "-" + month;
        },
        dateFormatYesterDay:function(b:number):string{
            b = b || new Date().getTime();
            const a = new Date((b));
            const year = a.getFullYear();
            let month:number|string = (a.getMonth()) + 1;
            month = (month < 10) ? "0" + month : month;
            let date:number|string = a.getDate()-1;
            date = (date < 10) ? "0" + date : date;
            return year + "-" + month + "-" + date;
        },
    },
    $localStorage:{
        addLocalStorage:function (key:any,val:any):any{
            window.localStorage.setItem(key, val);
        },
        getLocalStorage:function (key:any):any{
            return window.localStorage.getItem(key);
        },
        removeLocalStorage:function (key:any):any{
            window.localStorage.removeItem(key);
        }

    },
    $cookie:{
        addCookie:function(cName: string, value: any, expiredays: any){
            expiredays = expiredays || "100";
            if (expiredays > 0 && expiredays !== "100") {
                const exdate = new Date();
                exdate.setDate(exdate.getDate() + expiredays);
                document.cookie = cName + "=" + escape(value) + (expiredays === null ? "" : ";expires=" + exdate.toUTCString()) + ";path=/;";
            }

            if (expiredays === "100") {
                const exdate = new Date("2118-01-01 00:00:00");
                document.cookie = cName + "=" + escape(value) + (expiredays === null ? "" : ";expires=" + exdate.toUTCString()) + ";path=/;";
            }
        },
        getCookie:function(cName:string){
            const arr=document.cookie.split('; ');
            for(let i=0;i<arr.length;i++){
                const key = arr[i].substring(0,arr[i].indexOf('=')),
                    value = arr[i].substring(arr[i].indexOf('=')+1);
                if(cName === key){
                    return value;
                }
            }
            return '';
        },
        removeCookie:function(cName:string){
            this.addCookie(cName,'1',-1);
        },
        clearToken(){
            const date:any = new Date();
            date.setTime(date.getTime() - 10000);
            const keys = document.cookie.match(/[^ =;]+(?=\=)/g);
            if (keys) {
                for (let i = keys.length; i--;)
                document.cookie = keys[i] + "=0; expire=" + date.toGMTString() + "; path=/";
            }
        }

    },
    throttle:function(fn: any, delay: number, ...args:any){
        // last为上一次触发回调的时间，timer是定时器
        let last = 0,
            timer: any = null;
        // 将throttle处理结果当做函数返回
        return ()=>{
            // 保留调用时this的上下文
            const context = this;
            // 保留调用时传入的参数
            // const args = args;
            // 记录本次触发回调的时间
            const now = +new Date();

            // 判断上次触发的时间和本次触发的时间差是否小于时间间隔的阀值
            if( now - last < delay ) {
                // 如果时间间隔小于我们设定的时间间隔阀值，则为本次触发操作设立一个新的定时器
                clearTimeout(timer);
                timer = setTimeout(() => {
                    last = now;
                    fn.apply(context, args);
                }, delay);
            } else {
                // 如果时间间隔超出了我们设定的时间间隔阀值，那就不等了，无论如何要反馈给用户一次响应
                last = now;
                fn.apply(context, args);
            }
        };
    },
    arrayFn:{
         /**
         * 数组对象去重
         * @param {Array} arr  原始数组
         * @param {string} key  依据去重的key
        */
        uniqueArrByKey(arr: Array<any>,key: string){
          const m = new Map();
          return arr.filter((ele) => !m.has(ele[key]) && m.set(ele[key], ""));
        },
        /**
         * 两个数组合并成一个对象数组,考虑到复杂度,所以目前支持两个一维数组
         * @param {Array} arrOne
         * @param {Array} arrTwo
         * @param {oneKey} oneKey 选填,如果两个都未传,直接以 arrOne 的值作为 key,arrTwo 作为 value
         * @param {twoKey} twoKey
        */
        arrTwoToArrObj: function (arrOne: Array<any>, arrTwo: Array<any>, oneKey: string, twoKey: string){
            if(!oneKey&&!twoKey){
              return arrOne.map((oneKey, i) => ({ [oneKey]:arrTwo[i] }))
              // 或者,此方法针对将 arrTwo 的索引作为 key 的情况,arrTwo 值会覆盖 arrOne
             // return Object.assign({}, arrOne, arrTwo)
            }else{
              return arrOne.map((oneKey, i) => ({ oneKey, twoKey: arrTwo[i] }))
            }
        },
    },
    //获取url参数
    getUrl(name: any) {
        const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        const r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    },
    // 文件下载
    downExcel(val:any, name:any, isTem:any) {
        isTem = isTem === false ? isTem : true;
        const fileName = dayjs().format("YYYY年MM月DD日")+(name ? name : "") + (isTem ? "模板" : '');
        const blob = new Blob([val.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const downloadElement = document.createElement("a");
        const href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = fileName; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    // pdf下载
    pdfDow(val:any, name:any) {
        const fileName = dayjs().format("YYYY年MM月DD日")+name;
        const blob = new Blob([val.data], {
        type: "application/pdf"
        });
        const downloadElement = document.createElement("a");
        const href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        // downloadElement.download = fileName; //下载后文件名
        downloadElement.download = fileName; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    // pdf下载
    wordDow(val:any, name:any) {
        const fileName = dayjs().format("YYYY年MM月DD日")+name;
        const blob = new Blob([val.data], {
            type: "application/msword"
        });
        const downloadElement = document.createElement("a");
        const href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        // downloadElement.download = fileName; //下载后文件名
        downloadElement.download = fileName; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    // 金额转汉字
    convertCurrency(money: any){
        let isNegative = false;
        if(money < 0){
            isNegative = true;
            money = Math.abs(money);
        }
        //汉字的数字
        const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
        //基本单位
        const cnIntRadice = ['', '拾', '佰', '仟'];
        //对应整数部分扩展单位
        const cnIntUnits = ['', '万', '亿', '兆'];
        //对应小数部分单位
        const cnDecUnits = ['角', '分', '毫', '厘'];
        //整数金额时后面跟的字符
        const cnInteger = '整';
        //整型完以后的单位
        const cnIntLast = '元';
        //最大处理的数字
        const maxNum = 999999999999999.9999;
        //金额整数部分
        let integerNum;
        //金额小数部分
        let decimalNum;
        //输出的中文金额字符串
        let chineseStr = '';
        //分离金额后用的数组，预定义
        let parts;
        if (money == '') { return ''; }
            money = parseFloat(money);
        if (money >= maxNum) {
          //超出最大处理数字
          return '';
        }
        if (money == 0) {
          chineseStr = cnNums[0] + cnIntLast + cnInteger;
          return chineseStr;
        }
        //转换为字符串
        money = money.toString();
        if (money.indexOf('.') == -1) {
          integerNum = money;
          decimalNum = '';
        } else {
          parts = money.split('.');
          integerNum = parts[0];
          decimalNum = parts[1].substr(0, 4);
        }
        //获取整型部分转换
        if (parseInt(integerNum, 10) > 0) {
          let zeroCount = 0;
          const IntLen = integerNum.length;
          for (let i = 0; i < IntLen; i++) {
            const n = integerNum.substr(i, 1);
            const p = IntLen - i - 1;
            const q = p / 4;
            const m = p % 4;
            if (n == '0') {
              zeroCount++;
            } else {
              if (zeroCount > 0) {
                chineseStr += cnNums[0];
              }
              //归零
              zeroCount = 0;
              chineseStr += cnNums[parseInt(n)] +`<span>${cnIntRadice[m]}</span>`;
            }
            if (m == 0 && zeroCount < 4) {
              chineseStr += `<span>${cnIntUnits[q]}</span>`;
            }
          }
          chineseStr += `<span>${cnIntLast}</span>`;
        }
        //小数部分
        if (decimalNum != '') {
          const decLen = decimalNum.length;
          for (let i = 0; i < decLen; i++) {
            const n = decimalNum.substr(i, 1);
            if (n != '0') {
              chineseStr += cnNums[Number(n)] + `<span>${cnDecUnits[i]}</span>`;
            }
          }
        }
        if (chineseStr == '') {
          chineseStr += cnNums[0] + `<span>${cnIntLast}</span>` + cnInteger;
        } else if (decimalNum == '') {
          chineseStr += cnInteger;
        }
        return (isNegative?'负':'')+chineseStr;
    },
    rowNewWindowFn(type:any,id:any){
        let routerPath = "";
        switch (type) {
            case "common_contract":
              routerPath = "/workbench/authCommon";
              break;
            case "owner_contract":
              routerPath = "/workbench/authOwner";
              break;
            case "labour_contract":
              routerPath = "/workbench/authLabour";
              break;
            case "material_contract":
              routerPath = "/workbench/authMaterial";
              break;
            case "double_contract":
              routerPath = "/workbench/authDouble";
              break;
            case "labour_single_contract":
              routerPath = "/workbench/authSingleLabour";
              break;
            case "labour_double_contract":
              routerPath = "/workbench/authDoubleLabour";
              break;
            case "specially_contract":
              routerPath = "/workbench/authSpecially";
              break;
            case "material_purchase":
              routerPath = "/workbench/authPurchase";
              break;
            case "material_total_plan":
              routerPath = "/engineering/material/authMasterPlanDetail";
              break;
            case "material_sub_plan":
              routerPath = "/engineering/material/authBranchPlanDetail";
              break;
            case "labour_progress_payment":
              routerPath = "/engineering/labour/progress/authPay";
              break;
            case "labour_settlement_payment":
              routerPath = "/engineering/labour/settlement/authPay";
              break;
            case "instead_buy_material_progress_payment":
              routerPath = "/engineering/labour/agentProgress/authPay";
              break;
            case "instead_buy_material_settlement_payment":
              routerPath = "/engineering/labour/agentSettlement/authPay";
              break;
            case "double_progress_payment":
              routerPath = "/engineering/double/authProgressPay";
              break;
            case "double_settlement_payment":
              routerPath = "/engineering/double/authSettlementPay";
              break;
            case "material_progress_payment":
              routerPath = "/materialManagement/payment/authPro";
              break;
            case "material_prepaid_payment":
              routerPath = "/materialManagement/payment/authPro";
              break;
            case "material_settlement_payment":
              routerPath = "/materialManagement/payment/authSet";
              break;
            case "invoice_application":
              routerPath = "/workbench/billing/auth";
              break;
            case "engineering_reward_punishments":
              routerPath = "/engineering/safeManage/record/auth";
              break;
            case "quality_reward_punishments":
              routerPath = "/safe/authRewardsPunishments";
              break;
            case "material_inquiry":
              routerPath = "/workbench/inquiry/auth";
              break;
            case "borrowing":
              routerPath = "/workbench/loan/auth";
              break;
            case "reimbursement":
              routerPath = "/workbench/reimbursement/auth";
              break;
            case "seal_apply":
              routerPath = "/workbench/sealManage/auth";
              break;
            case "leave_order_1":
              routerPath = "/workbench/leaveManage/auth";
              break;
            case "leave_order_2":
              routerPath = "/workbench/leaveManage/auth";
              break;
            case "common_flow":
              routerPath = "/workbench/commonManage/auth";
              break;
            case "travel_order":
              routerPath = "/workbench/travelManage/auth";
              break;
            case "office_supplies_purchase":
              routerPath = "/workbench/officePurchase/auth";
              break;
            case "office_supplies_use":
              routerPath = "/workbench/officeUse/auth";
              break;
            case "sporadic_material_progress_payment":
              routerPath = "/materialManagement/payment/authScatterPro";
              break;
            case "sporadic_material_settlement_payment":
              routerPath = "/materialManagement/payment/authScatterSet";
              break;
            case "labour_payment_confirm":
              routerPath = "/generalDepartment/labourPayment/list";
              break;
            case "material_payment_confirm":
              routerPath = "/materialManagement/payment/list";
              break;
            case "labour_double_progress_payment":
              routerPath = "/engineering/labour/dlProgress/authPay";
              break;
            case "labour_double_settlement_payment":
              routerPath = "/engineering/labour/dlSettlement/authPay";
              break;
            case "specially_prepaid_payment":
              routerPath = "/engineering/double/special/authPrePay";
              break;
            case "specially_progress_payment":
              routerPath = "/engineering/double/special/authProgressPay";
              break;
            case "specially_settlement_payment":
              routerPath = "/engineering/double/special/authSettlementPay";
              break;
            case "labour_single_progress_payment":
              routerPath = "/engineering/labour/progress/authPay";
              break;
            case "labour_single_settlement_payment":
              routerPath = "/engineering/labour/settlement/authPay";
              break;
        }

        window.open(
            `${window.location.origin}${routerPath}?id=${id}`
        );
    },
    applyAndAuthDir:{
      labour_progress_payment: {
        addPath: "/engineering/labour/progress/applyPay",
        authPath: "/engineering/labour/progress/authPay",
      },
      labour_settlement_payment: {
        addPath: "/engineering/labour/settlement/applyPay",
        authPath: "/engineering/labour/settlement/authPay",
      },
      labour_single_progress_payment: {
        addPath: "/engineering/labour/progress/applyPay",
        authPath: "/engineering/labour/progress/authPay",
      },
      labour_single_settlement_payment: {
        addPath: "/engineering/labour/settlement/applyPay",
        authPath: "/engineering/labour/settlement/authPay",
      },
      instead_buy_material_progress_payment: {
        addPath: "/engineering/labour/agentProgress/applyPay",
        authPath: "/engineering/labour/agentProgress/authPay",
      },
      instead_buy_material_settlement_payment: {
        addPath: "/engineering/labour/agentSettlement/applyPay",
        authPath: "/engineering/labour/agentSettlement/authPay",
      },
      double_progress_payment: {
        addPath: "/engineering/double/applyProgressPay",
        authPath: "/engineering/double/authProgressPay",
      },
      double_settlement_payment: {
        addPath: "/engineering/double/applySettlementPay",
        authPath: "/engineering/double/authSettlementPay",
      },
      material_progress_payment: {
        addPath: "/materialManagement/payment/applyPro",
        authPath: "/materialManagement/payment/authPro",
      },
      material_prepaid_payment: {
        addPath: "/materialManagement/payment/applyPrepaidPro",
        authPath: "/materialManagement/payment/authPro",
      },
      material_settlement_payment: {
        addPath: "/materialManagement/payment/applySet",
        authPath: "/materialManagement/payment/authSet",
      },
      sporadic_material_progress_payment: {
        addPath: "/materialManagement/payment/applyScatterPro",
        authPath: "/materialManagement/payment/authScatterPro",
      },
      sporadic_material_settlement_payment: {
        addPath: "/materialManagement/payment/applyScatterSet",
        authPath: "/materialManagement/payment/authScatterSet",
      },
      labour_double_progress_payment:{
        addPath: "/engineering/labour/dlProgress/applyPay",
        authPath: "/engineering/labour/dlProgress/authPay",
      },
      labour_double_settlement_payment:{
        addPath: "/engineering/labour/dlSettlement/applyPay",
        authPath: "/engineering/labour/dlSettlement/authPay",
      },
      specially_prepaid_payment:{
        addPath: "/engineering/double/special/applyPrePay",
        authPath: "/engineering/double/special/authPrePay",
      },
      specially_progress_payment:{
        addPath: "/engineering/double/special/applyProgressPay",
        authPath: "/engineering/double/special/authProgressPay",
      },
      specially_settlement_payment:{
        addPath: "/engineering/double/special/applySettlementPay",
        authPath: "/engineering/double/special/authSettlementPay",
      }
    },
    $currencyRun: function(money:any){
      let data
      const returnObj:any = {}
      let dw = ''
      let chengshu = 1
      if (isNaN(money)) {
        data = 0
      } else {
        data = parseFloat(money) || 0;
      }
      if (Math.abs(data) < 10000) {
        if ((data + '').indexOf('.') >= 0) {
          returnObj.value = data.toFixed(2)
        } else {
          returnObj.value = data.toFixed(0)
        }
      } else if (Math.abs(data) >= 10000 && Math.abs(data) < 100000000) {
        data = data * 0.0001
        chengshu = 0.0001
        returnObj.value = data.toFixed(2)
        dw = '万'
      } else if (Math.abs(data) >= 100000000 && Math.abs(data) < 1000000000000) {
        data = data * 0.00000001
        chengshu = 0.00000001
        returnObj.value = data.toFixed(2)
        dw = '亿'
      } else {
        data = data * 0.000000000001
        chengshu = 0.000000000001
        dw = '万亿'
        returnObj.value = data.toFixed(2)
      }
      returnObj.dw = dw
      returnObj.chengshu = currency(data, { symbol: '' }).format()
      returnObj.all = currency(data, { symbol: '' }).format()+''+dw
      return returnObj;
      
    }
};

export default util